import React from "react";
import Subscriber from "../../subscriber.class";
import Map from "../map/map.component";
import Storage from "../../services/storage.service";
import { goToStart } from "../../services/flow.service";
import { getLocalAddressComponent } from "../../services/maps.service";
import { t } from "../../services/translation.service";
// import { getSplitText } from "../../services/helpers";
import { generalEvent } from "../../services/tracking.service";

import {
  findCoveragePlace,
  getCoveragePlaceLatLng,
  getCoveragePlace,
} from "../../services/coverage.service";
import Settings from "../../services/settings.service";
import { CoverageCheckMapID } from "../../static/fields.data";
import Spinner from "../spinners/spinner";

export default class SummaryLocation extends Subscriber {
  state = {
    coverage_place: null,
    coverage_data: null,
  };

  constructor() {
    super();
    this.mapRef = React.createRef();
  }

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("modem_latlng").subscribe((latLng) => {
        if (latLng) {
          findCoveragePlace(latLng);
        }
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("map_" + CoverageCheckMapID + "_last_place").subscribe(
        (coverage_place) => {
          this.setState({
            ready: !!coverage_place,
          });
        }
      )
    );

    this.subscriptions.push(
      Storage.get_obsrv("coverage_data").subscribe((coverage_data) => {
        this.setState({
          coverage_data: coverage_data,
        });
      })
    );
  }

  changeLocation = () => {
    goToStart();
  };

  render() {
    let content = "";

    if (!this.state.ready) {
      content = <Spinner />;
    } else {
      let coverage_place = getCoveragePlace();
      let markerLatLng = getCoveragePlaceLatLng();
      let coverage_data = this.state.coverage_data;

      let notice = "";

      if (
        this.props.show_notice &&
        coverage_data &&
        coverage_data["is_covered"]
      ) {
        let notice_line = t("LOCATION_SUMMARY_BOX_NOTICE");
        let notice_line_bold = t("LOCATION_SUMMARY_BOX_NOTICE_BOLD");

        notice = (
          <div className="vmo-summary-suffix-inside">
            <div className="vmo-summary-suffix vmo-summary-warning">
              <div className="vmo-summary-suffix-inner">
                <div className="vmo-summary-suffix-body vmo-summary-suffix-vertical">
                  {notice_line_bold ? (
                    <strong> {notice_line_bold} </strong>
                  ) : (
                    ""
                  )}
                  {notice_line}{" "}
                  <br/>
                  <a
                    href={Settings.modem_info_link}
                    // target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("LOCATION_SUMMARY_BOX_NOTICE_MORE")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      }
      let title = "";
      let delivery_location_line = "";
      // let speed = "";
      // let speed_value = "";

      // if (coverage_data) {
      //   speed_value = t("LOCATION_SUMMARY_BOX_UPTO");
      //   speed_value = getSplitText(
      //     speed_value,
      //     "%COVERAGE%",
      //     coverage_data["coverage_type"]
      //   );
      // }

      let city = getLocalAddressComponent(coverage_place);

      if (this.props.title) {
        title = this.props.title;
        delivery_location_line = (
          <div className="vmo-plan-specs vmo-summary-address">
            <div className="vmo-summary-plan-spec">{city ? city : ""}</div>
          </div>
        );

        // if (speed_value) {
        //   speed = (
        //     <div className="vmo-plan-specs">
        //       <div className="vmo-plan-spec vmo-plan-spec-data">
        //         <span className="vmo-plan-spec-value">{speed_value}</span>
        //       </div>
        //     </div>
        //   );
        // }
      } else {
        title = city ? city : "";
      }

      let field = "";
      if (this.props.field) {
        field = <div className="vmo-summary-checkbox">{this.props.field}</div>;
      }

      content = (
        <>
          <div className="vmo-summary-section-header">
            <h3> {title} </h3>
            <div
              className="vmo-summary-edit"
              onClick={() => {
                this.changeLocation();
                Storage.clear("summary_modal");
                let eventObj = {
                  eventCustomName : "click_cta",
                  extra_obj : {
                    cta_name: 'edit location',
                    cta_type: 'button',
                    cta_position: 'top'
                  }
                }
                generalEvent(eventObj);
              }}
            />
          </div>
          <div className="vmo-summary-map">
            <Map
              id={"CoverageMap1"}
              ref={this.mapRef}
              marker={markerLatLng}
              freeze={true}
              size="small"
              disable_search={true}
            />
            {delivery_location_line}
            {/* {speed} */}
          </div>
          {field}
          {notice}
        </>
      );
    }

    return (
      <div className="vmo-summary">
        <div className="vmo-summary-section ">
          <div className="vmo-summary-box-wrapper3">
            <div className="vmo-summary-box vmo-summary-box2">{content}</div>
          </div>
        </div>
      </div>
    );
  }
}
